export default "__VITE_ASSET__LJ9in4sB__"